"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compensationStatementExportQuerySchema = exports.selfCompensationEstimateResponseSchema = exports.selfCompensationEstimateSchema = exports.selfCompensationEstimateQuerySchema = exports.compensationStatementResponseSchema = exports.compensationStatementItemSchema = exports.compensationStatementQuerySchema = exports.addCompensationAdjustmentRequestSchema = exports.approveCompensationCalculationRequestSchema = exports.compensationCalculationListResponseSchema = exports.compensationCalculationListQuerySchema = exports.compensationCalculationSchema = exports.compensationActivitySchema = exports.compensationCalculationStatusSchema = exports.compensationCalculationItemSchema = exports.compensationBasisSnapshotSchema = exports.compensationSourceSnapshotSchema = exports.calculateJobCompensationRequestSchema = exports.compensationBasisOverrideSchema = exports.compensationParticipantOverrideSchema = exports.compensationPlanListResponseSchema = exports.compensationPlanListQuerySchema = exports.createCompensationPlanRequestSchema = exports.compensationPlanSchema = exports.compensationRuleSchema = exports.splitCompensationRuleSchema = exports.commissionCompensationRuleSchema = exports.percentageCompensationRuleSchema = exports.hourlyCompensationRuleSchema = exports.flatCompensationRuleSchema = exports.compensationBasisPolicySchema = exports.compensationDeductionTreatmentSchema = exports.compensationRevenueTreatmentSchema = exports.compensationBasisComponentSchema = exports.compensationCalculationTypeSchema = exports.COMPENSATION_STATEMENT_CSV_SCHEMA_VERSION = exports.COMPENSATION_CONTRACT_VERSION = void 0;
const zod_1 = require("zod");
const pagination_1 = require("./pagination");
exports.COMPENSATION_CONTRACT_VERSION = 1;
exports.COMPENSATION_STATEMENT_CSV_SCHEMA_VERSION = "1.0.0";
exports.compensationCalculationTypeSchema = zod_1.z.enum([
    "FLAT",
    "HOURLY",
    "PERCENTAGE",
    "COMMISSION",
    "SPLIT",
]);
exports.compensationBasisComponentSchema = zod_1.z.enum([
    "SERVICE_REVENUE",
    "LABOR_REVENUE",
    "DISCOUNT",
    "TAX",
    "TIP",
    "FEE",
    "REFUND",
]);
exports.compensationRevenueTreatmentSchema = zod_1.z.enum([
    "INCLUDE",
    "EXCLUDE",
]);
exports.compensationDeductionTreatmentSchema = zod_1.z.enum([
    "DEDUCT",
    "IGNORE",
]);
exports.compensationBasisPolicySchema = zod_1.z
    .object({
    serviceRevenue: exports.compensationRevenueTreatmentSchema,
    laborRevenue: exports.compensationRevenueTreatmentSchema,
    discount: exports.compensationDeductionTreatmentSchema,
    tax: exports.compensationRevenueTreatmentSchema,
    tip: exports.compensationRevenueTreatmentSchema,
    fee: exports.compensationDeductionTreatmentSchema,
    refund: exports.compensationDeductionTreatmentSchema,
})
    .strict();
exports.flatCompensationRuleSchema = zod_1.z
    .object({
    type: zod_1.z.literal("FLAT"),
    amountCents: zod_1.z.number().int().min(0).max(100_000_000),
})
    .strict();
exports.hourlyCompensationRuleSchema = zod_1.z
    .object({
    type: zod_1.z.literal("HOURLY"),
    hourlyRateCents: zod_1.z.number().int().min(0).max(10_000_000),
    includeTravelTime: zod_1.z.boolean(),
})
    .strict();
exports.percentageCompensationRuleSchema = zod_1.z
    .object({
    type: zod_1.z.literal("PERCENTAGE"),
    rateBasisPoints: zod_1.z.number().int().min(0).max(100_000),
})
    .strict();
exports.commissionCompensationRuleSchema = zod_1.z
    .object({
    type: zod_1.z.literal("COMMISSION"),
    rateBasisPoints: zod_1.z.number().int().min(0).max(100_000),
    thresholdCents: zod_1.z.number().int().min(0).max(1_000_000_000),
})
    .strict();
exports.splitCompensationRuleSchema = zod_1.z
    .object({
    type: zod_1.z.literal("SPLIT"),
    poolRateBasisPoints: zod_1.z.number().int().min(0).max(100_000),
})
    .strict();
exports.compensationRuleSchema = zod_1.z.discriminatedUnion("type", [
    exports.flatCompensationRuleSchema,
    exports.hourlyCompensationRuleSchema,
    exports.percentageCompensationRuleSchema,
    exports.commissionCompensationRuleSchema,
    exports.splitCompensationRuleSchema,
]);
exports.compensationPlanSchema = zod_1.z
    .object({
    id: zod_1.z.string().uuid(),
    contractVersion: zod_1.z.literal(exports.COMPENSATION_CONTRACT_VERSION),
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    operationalLocationId: zod_1.z.string().uuid().nullable(),
    membershipId: zod_1.z.string().uuid().nullable(),
    name: zod_1.z.string().trim().min(1).max(120),
    currency: zod_1.z.literal("USD"),
    effectiveAt: zod_1.z.string().datetime(),
    rule: exports.compensationRuleSchema,
    basisPolicy: exports.compensationBasisPolicySchema,
    createdByMembershipId: zod_1.z.string().uuid(),
    createdAt: zod_1.z.string().datetime(),
})
    .strict();
exports.createCompensationPlanRequestSchema = zod_1.z
    .object({
    operationalLocationId: zod_1.z.string().uuid().nullable().default(null),
    membershipId: zod_1.z.string().uuid().nullable().default(null),
    name: zod_1.z.string().trim().min(1).max(120),
    effectiveAt: zod_1.z.string().datetime(),
    rule: exports.compensationRuleSchema,
    basisPolicy: exports.compensationBasisPolicySchema,
})
    .strict();
exports.compensationPlanListQuerySchema = zod_1.z.object({
    operationalLocationId: zod_1.z.string().uuid().optional(),
    membershipId: zod_1.z.string().uuid().optional(),
    effectiveAt: zod_1.z.string().datetime().optional(),
});
exports.compensationPlanListResponseSchema = zod_1.z
    .object({
    contractVersion: zod_1.z.literal(exports.COMPENSATION_CONTRACT_VERSION),
    items: zod_1.z.array(exports.compensationPlanSchema),
    canManage: zod_1.z.boolean(),
    canApprove: zod_1.z.boolean(),
})
    .strict();
exports.compensationParticipantOverrideSchema = zod_1.z
    .object({
    membershipId: zod_1.z.string().uuid(),
    planId: zod_1.z.string().uuid().nullable().default(null),
    splitWeightBasisPoints: zod_1.z.number().int().min(1).max(100_000),
})
    .strict();
exports.compensationBasisOverrideSchema = zod_1.z
    .object({
    discountCents: zod_1.z.number().int().min(0).max(1_000_000_000).optional(),
    tipCents: zod_1.z.number().int().min(0).max(1_000_000_000).optional(),
    feeCents: zod_1.z.number().int().min(0).max(1_000_000_000).optional(),
    reason: zod_1.z.string().trim().min(5).max(500),
})
    .strict();
exports.calculateJobCompensationRequestSchema = zod_1.z
    .object({
    operationalLocationId: zod_1.z.string().uuid(),
    asOf: zod_1.z.string().datetime().optional(),
    basisOverride: exports.compensationBasisOverrideSchema.optional(),
    participants: zod_1.z.array(exports.compensationParticipantOverrideSchema).min(1).max(50),
})
    .strict()
    .superRefine((value, context) => {
    const ids = value.participants.map((participant) => participant.membershipId);
    if (new Set(ids).size !== ids.length) {
        context.addIssue({
            code: "custom",
            path: ["participants"],
            message: "Each technician can appear only once.",
        });
    }
});
exports.compensationSourceSnapshotSchema = zod_1.z
    .object({
    jobId: zod_1.z.string().uuid(),
    jobNumber: zod_1.z.number().int().positive(),
    operationalLocationId: zod_1.z.string().uuid(),
    currency: zod_1.z.literal("USD"),
    sourceCompletedAt: zod_1.z.string().datetime().nullable(),
    serviceRevenueCents: zod_1.z.number().int().nonnegative(),
    laborRevenueCents: zod_1.z.number().int().nonnegative(),
    discountCents: zod_1.z.number().int().nonnegative(),
    taxCents: zod_1.z.number().int().nonnegative(),
    tipCents: zod_1.z.number().int().nonnegative(),
    feeCents: zod_1.z.number().int().nonnegative(),
    refundCents: zod_1.z.number().int().nonnegative(),
    refundDeduplication: zod_1.z.literal("PAYMENT_ID"),
    capturedAt: zod_1.z.string().datetime(),
})
    .strict();
exports.compensationBasisSnapshotSchema = zod_1.z
    .object({
    serviceRevenueCents: zod_1.z.number().int().nonnegative(),
    laborRevenueCents: zod_1.z.number().int().nonnegative(),
    discountCents: zod_1.z.number().int().nonnegative(),
    taxCents: zod_1.z.number().int().nonnegative(),
    tipCents: zod_1.z.number().int().nonnegative(),
    feeCents: zod_1.z.number().int().nonnegative(),
    refundCents: zod_1.z.number().int().nonnegative(),
    eligibleBasisCents: zod_1.z.number().int(),
})
    .strict();
exports.compensationCalculationItemSchema = zod_1.z
    .object({
    id: zod_1.z.string().uuid(),
    membershipId: zod_1.z.string().uuid(),
    technicianName: zod_1.z.string().nullable(),
    planId: zod_1.z.string().uuid(),
    planName: zod_1.z.string(),
    rule: exports.compensationRuleSchema,
    basisPolicy: exports.compensationBasisPolicySchema,
    basis: exports.compensationBasisSnapshotSchema,
    workSeconds: zod_1.z.number().int().nonnegative(),
    travelSeconds: zod_1.z.number().int().nonnegative(),
    splitWeightBasisPoints: zod_1.z.number().int().min(1).max(100_000),
    amountCents: zod_1.z.number().int(),
    adjustmentCents: zod_1.z.number().int(),
    finalAmountCents: zod_1.z.number().int(),
})
    .strict();
exports.compensationCalculationStatusSchema = zod_1.z.enum([
    "DRAFT",
    "APPROVED",
]);
exports.compensationActivitySchema = zod_1.z
    .object({
    id: zod_1.z.string().uuid(),
    type: zod_1.z.enum(["CALCULATED", "APPROVED", "ADJUSTED"]),
    detail: zod_1.z.string().nullable(),
    actorMembershipId: zod_1.z.string().uuid(),
    actorName: zod_1.z.string().nullable(),
    occurredAt: zod_1.z.string().datetime(),
})
    .strict();
exports.compensationCalculationSchema = zod_1.z
    .object({
    id: zod_1.z.string().uuid(),
    contractVersion: zod_1.z.literal(exports.COMPENSATION_CONTRACT_VERSION),
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    jobId: zod_1.z.string().uuid(),
    operationalLocationId: zod_1.z.string().uuid(),
    status: exports.compensationCalculationStatusSchema,
    source: exports.compensationSourceSnapshotSchema,
    items: zod_1.z.array(exports.compensationCalculationItemSchema),
    totalAmountCents: zod_1.z.number().int(),
    sourceFingerprint: zod_1.z.string().min(16).max(128),
    calculatedByMembershipId: zod_1.z.string().uuid(),
    calculatedAt: zod_1.z.string().datetime(),
    approvedByMembershipId: zod_1.z.string().uuid().nullable(),
    approvedAt: zod_1.z.string().datetime().nullable(),
    activities: zod_1.z.array(exports.compensationActivitySchema),
    disclaimer: zod_1.z.literal("Compensation estimates are operational records, not payroll or tax calculations."),
})
    .strict();
exports.compensationCalculationListQuerySchema = zod_1.z.object({
    operationalLocationId: zod_1.z.string().uuid().optional(),
    membershipId: zod_1.z.string().uuid().optional(),
    status: exports.compensationCalculationStatusSchema.optional(),
    from: zod_1.z.string().datetime().optional(),
    to: zod_1.z.string().datetime().optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(50),
    cursor: zod_1.z.string().trim().min(1).max(4_096).optional(),
});
exports.compensationCalculationListResponseSchema = zod_1.z
    .object({
    contractVersion: zod_1.z.literal(exports.COMPENSATION_CONTRACT_VERSION),
    items: zod_1.z.array(exports.compensationCalculationSchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
    canApprove: zod_1.z.boolean(),
})
    .strict();
exports.approveCompensationCalculationRequestSchema = zod_1.z
    .object({
    expectedSourceFingerprint: zod_1.z.string().min(16).max(128),
})
    .strict();
exports.addCompensationAdjustmentRequestSchema = zod_1.z
    .object({
    membershipId: zod_1.z.string().uuid(),
    amountCents: zod_1.z.number().int().min(-100_000_000).max(100_000_000),
    reason: zod_1.z.string().trim().min(5).max(500),
})
    .strict()
    .refine((value) => value.amountCents !== 0, {
    path: ["amountCents"],
    message: "Adjustment amount cannot be zero.",
});
const compensationStatementQueryFields = {
    from: zod_1.z.string().datetime(),
    to: zod_1.z.string().datetime(),
    membershipId: zod_1.z.string().uuid().optional(),
    operationalLocationId: zod_1.z.string().uuid().optional(),
};
const validateCompensationStatementRange = (value, context) => {
    const from = Date.parse(value.from);
    const to = Date.parse(value.to);
    if (to <= from) {
        context.addIssue({
            code: "custom",
            path: ["to"],
            message: "The end of the range must be after the start.",
        });
    }
    if (to - from > 366 * 24 * 60 * 60 * 1_000) {
        context.addIssue({
            code: "custom",
            path: ["to"],
            message: "Statement ranges cannot exceed 366 days.",
        });
    }
};
exports.compensationStatementQuerySchema = zod_1.z
    .object({
    ...compensationStatementQueryFields,
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(50),
    cursor: zod_1.z.string().trim().min(1).max(4_096).optional(),
})
    .superRefine((value, context) => {
    validateCompensationStatementRange(value, context);
});
exports.compensationStatementItemSchema = zod_1.z
    .object({
    calculationId: zod_1.z.string().uuid(),
    calculationItemId: zod_1.z.string().uuid(),
    jobId: zod_1.z.string().uuid(),
    jobNumber: zod_1.z.number().int().positive(),
    operationalLocationId: zod_1.z.string().uuid(),
    membershipId: zod_1.z.string().uuid(),
    technicianName: zod_1.z.string().nullable(),
    approvedAt: zod_1.z.string().datetime(),
    amountCents: zod_1.z.number().int(),
    adjustmentCents: zod_1.z.number().int(),
    finalAmountCents: zod_1.z.number().int(),
    currency: zod_1.z.literal("USD"),
})
    .strict();
exports.compensationStatementResponseSchema = zod_1.z
    .object({
    contractVersion: zod_1.z.literal(exports.COMPENSATION_CONTRACT_VERSION),
    items: zod_1.z.array(exports.compensationStatementItemSchema),
    totals: zod_1.z.object({
        amountCents: zod_1.z.number().int(),
        adjustmentCents: zod_1.z.number().int(),
        finalAmountCents: zod_1.z.number().int(),
    }),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
    disclaimer: zod_1.z.literal("Compensation estimates are operational records, not payroll or tax calculations."),
})
    .strict();
exports.selfCompensationEstimateQuerySchema = zod_1.z
    .object({
    jobId: zod_1.z.string().uuid().optional(),
    from: zod_1.z.string().datetime().optional(),
    to: zod_1.z.string().datetime().optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(50).default(20),
})
    .superRefine((value, context) => {
    if (Boolean(value.from) !== Boolean(value.to)) {
        context.addIssue({
            code: "custom",
            path: [value.from ? "to" : "from"],
            message: "Estimate ranges require both from and to.",
        });
        return;
    }
    const { from, to } = value;
    if (!from || !to)
        return;
    validateCompensationStatementRange({ from, to }, context);
});
exports.selfCompensationEstimateSchema = zod_1.z
    .object({
    calculationId: zod_1.z.string().uuid(),
    jobId: zod_1.z.string().uuid(),
    jobNumber: zod_1.z.number().int().positive(),
    operationalLocationId: zod_1.z.string().uuid(),
    status: exports.compensationCalculationStatusSchema,
    estimatedAmountCents: zod_1.z.number().int(),
    currency: zod_1.z.literal("USD"),
    calculatedAt: zod_1.z.string().datetime(),
})
    .strict();
exports.selfCompensationEstimateResponseSchema = zod_1.z
    .object({
    contractVersion: zod_1.z.literal(exports.COMPENSATION_CONTRACT_VERSION),
    items: zod_1.z.array(exports.selfCompensationEstimateSchema),
    disclaimer: zod_1.z.literal("Compensation estimates are operational records, not payroll or tax calculations."),
})
    .strict();
exports.compensationStatementExportQuerySchema = zod_1.z
    .object(compensationStatementQueryFields)
    .superRefine((value, context) => {
    validateCompensationStatementRange(value, context);
});
//# sourceMappingURL=compensation.js.map